import type { ReactNode } from "react";
import "./GameContainer.css";

interface GameContainerProps {
  children: ReactNode;
}

export function GameContainer({ children }: GameContainerProps) {
  return <div className="game-container">{children}</div>;
}
